import {
  GET_MENUS_REQUESTED,
  GET_MENUS_SUCCEEDED,
  GET_MENUS_FAILED,
  CREATE_MENUS_REQUESTED,
  CREATE_MENUS_SUCCEEDED,
  CREATE_MENUS_FAILED,
  UPDATE_MENUS_REQUESTED,
  UPDATE_MENUS_SUCCEEDED,
  UPDATE_MENUS_FAILED,
} from './constants'
import api from '../../utils/api'

export const getMenusRequested = () => ({
  type: GET_MENUS_REQUESTED,
})

export const getMenusSucceeded = (payload) => ({
  type: GET_MENUS_SUCCEEDED,
  payload,
})

export const getMenusFailed = () => ({
  type: GET_MENUS_FAILED,
})

export const createMenusRequested = () => ({
  type: CREATE_MENUS_REQUESTED,
})

export const createMenusSucceeded = (payload) => ({
  type: CREATE_MENUS_SUCCEEDED,
  payload,
})

export const createMenusFailed = () => ({
  type: CREATE_MENUS_FAILED,
})

export const updateMenusRequested = () => ({
  type: UPDATE_MENUS_REQUESTED,
})

export const updateMenusSucceeded = (payload) => ({
  type: UPDATE_MENUS_SUCCEEDED,
  payload,
})

export const updateMenusFailed = () => ({
  type: UPDATE_MENUS_FAILED,
})

export const loadMenus =
  (venueUuid, includeSettings) => (dispatch) => {
    dispatch(getMenusRequested())

    return api
      .fetchMenus(venueUuid, includeSettings)
      .then((response) =>
        dispatch(getMenusSucceeded(response.data.menus))
      )
      .catch(() => dispatch(getMenusFailed()))
  }

export const createMenus = (data) => (dispatch) => {
  dispatch(createMenusRequested())

  return api
    .createMenus(data)
    .then((response) =>
      dispatch(createMenusSucceeded(response.data.menus))
    )
    .catch((err) => dispatch(createMenusFailed(err)))
}

export const updateMenus = (data) => (dispatch) => {
  dispatch(updateMenusRequested())
  return api
    .updateMenus(data)
    .then((response) =>
      dispatch(updateMenusSucceeded(response.data.menus))
    )
    .catch((err) => dispatch(updateMenusFailed(err)))
}
